module.exports = __webpack_public_path__ + "media/entities/1802-17d71902.png";